import EditActivity from './EditActivity';

export default EditActivity;
